import * as React from "react"
import type { IconProps } from "../types"

const TruckMini = React.forwardRef<SVGSVGElement, IconProps>(
  ({ color = "currentColor", size = 14, ...props }, ref) => {
    return (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width={size}
        height={size}
        fill="none"
        ref={ref}
        {...props}
      >
        <path
          fill={color}
          fillRule="evenodd"
          d="M5.104 2.33337C4.86238 2.33337 4.6665 2.52925 4.6665 2.77087V3.50004H2.9165C2.77294 3.50004 2.63851 3.57047 2.55679 3.68851L1.24429 5.58434C1.19364 5.65751 1.1665 5.74438 1.1665 5.83337V9.47921C1.1665 9.72083 1.36238 9.91671 1.604 9.91671H2.3387C2.41316 10.8956 3.23103 11.6667 4.229 11.6667C5.22697 11.6667 6.04485 10.8956 6.11931 9.91671H7.88036C7.95483 10.8956 8.7727 11.6667 9.77067 11.6667C10.7686 11.6667 11.5865 10.8956 11.661 9.91671H12.3957C12.6373 9.91671 12.8332 9.72083 12.8332 9.47921V2.77087C12.8332 2.52925 12.6373 2.33337 12.3957 2.33337H5.104ZM4.6665 4.37504H3.14573L2.0415 5.97004V9.04171H2.47847C2.76417 8.3566 3.44035 7.87504 4.229 7.87504C4.37958 7.87504 4.52606 7.8926 4.6665 7.92577V4.37504ZM10.5615 9.12532C10.6037 9.24954 10.6662 9.36437 10.7451 9.46581C10.7753 9.56214 10.7915 9.66461 10.7915 9.77087C10.7915 10.3347 10.3345 10.7917 9.77067 10.7917C9.20688 10.7917 8.74984 10.3347 8.74984 9.77087C8.74984 9.20708 9.20688 8.75004 9.77067 8.75004C10.0896 8.75004 10.3743 8.89627 10.5615 9.12532ZM4.229 8.75004C3.66521 8.75004 3.20817 9.20708 3.20817 9.77087C3.20817 10.3347 3.66521 10.7917 4.229 10.7917C4.79279 10.7917 5.24984 10.3347 5.24984 9.77087C5.24984 9.20708 4.79279 8.75004 4.229 8.75004Z"
        />
      </svg>
    )
  }
)
TruckMini.displayName = "TruckMini"

export default TruckMini
